import {v4 as uuidv4} from 'uuid';

export interface SupplyEntryParams {
    objectID: string;
    articleNumber: string;
    amount: number;
    unit: string;
    quantity: number;
    articleDescription: string;
    date: Date;
    pricePerUnit: number;
    priceTotal: string;
    length: number;
    width: number;
    thickness: number;
    serviceID?: string;
    mandator: string;
    servicePosID?: string;
    employeeNr: number;
    objectName?: string;
    productType: number;
    rowID?: string;
}

export class SupplyEntry {
    objectID: string;
    FK_ObjectID: string;
    FK_ServiceID?: string;
    FK_EmployeeNo: number;
    Mandator: string;
    ServicePosID: string;
    articleNumber: string;
    quantity: number;
    rowID: string;
    unit: string;
    amount: number;
    articleDescription: string;
    date: Date;
    pricePerUnit: number;
    priceTotal: string;
    productType: number;

    deleted: boolean = false;
    uploaded: boolean = false;

    length: number;
    width: number;
    thickness: number;

    readyForExport: boolean;
    exported: boolean;
    objectName?: string;

    constructor({objectID, articleNumber, amount, unit, quantity, articleDescription, date, pricePerUnit, priceTotal, length, width, thickness, serviceID, mandator, servicePosID, employeeNr, objectName, productType, rowID}: SupplyEntryParams) {
        this.objectID = objectID;
        this.articleNumber = articleNumber;
        this.pricePerUnit = pricePerUnit;
        this.priceTotal = priceTotal;
        this.length = length;
        this.width = width;
        this.thickness = thickness;
        this.rowID ??= uuidv4();
        this.unit = unit;
        this.amount = amount;
        this.quantity = quantity;
        this.articleDescription = articleDescription;
        this.date = date;
        this.readyForExport = false;
        this.exported = false;
        this.FK_ObjectID = objectID;
        this.FK_ServiceID = serviceID;
        this.Mandator = mandator;
        this.ServicePosID ??= uuidv4();
        this.FK_EmployeeNo = employeeNr;
        this.objectName = objectName;
        this.productType = productType;
    }
}

export interface Order {

}